import { useEffect, useState } from "react";
import TabsComponent from "../tabswitches";
import { CircularProgress } from "@mui/material";
import api from "../../../../api/api";
import LineChart from "../../../../graphs/linegraphs/linegraph";
import WLMLineChart from "../../../../graphs/linegraphs/wlmlinegraph";

const RPM = ({dataId}) => {
  const [graphSwitch, setGraphSwitch] = useState({
    Systolic: true, // Initially set to false for not displaying Systolic
    Diastolic: true, // Initially set to false for not displaying Diastolic
    Pulse: true, // Initially set to true for displaying Pulse
  });
const [dataLoading, setDataLoading] = useState(false);
  const [rpmData,setRpmData] = useState([]); // State for fetching the lab data
  const [wlmData, setWlmData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const[bpploading,setBppLoading]=useState(false);
  const [selectedTab, setSelectedTab] = useState(0); 
  const practiseid = window.getPracticeId();

 const PatientIDRPM=dataId.patientid
 
  const fetchrpmData = async () => {
    setIsLoading(true);
    setBppLoading(true);
      setDataLoading(true);
    try {
      // Prepare the payload
      const payload = {
      
      }
  
      // Make the API call with the payload
      const response = await api.post(`/v1/${practiseid}/patient/${PatientIDRPM}/rpm/bpp-master`, payload);
  
      if (response.status === 200) {
        // Successfully fetched data
        setRpmData(response.data);
      }
    } catch (error) {
      console.error("Error fetching lab data:", error.response ? error.response.data : error);
    } finally {
      setIsLoading(false);
      setBppLoading(false);
        setDataLoading(false);
    }
  };
  
  const fetchWlmData = async () => {
    setIsLoading(true);
    try {
      const payload = {
      
      }
  
      const response = await api.post(`/v1/${practiseid}/patient/${PatientIDRPM}/rpm/wlm-master`,payload);
      if (response.status === 200) {
        setWlmData(response.data);
      }
    } catch (error) {
      console.error("Error fetching WLM data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchrpmData();
    fetchWlmData();
  }, []);
  
  console.log('WLM Data',wlmData)

  console.log("RPM data from API:", rpmData);
   
  const toggleGraph = (type) => {
    setGraphSwitch((prevState) => ({
      ...prevState,
      [type]: !prevState[type],
    }));
  };

  const filteredChartData = {
    labels: rpmData.datelabel || [],
    datasets: [
      {
        label: "Systolic",
        data: rpmData.systolic || [],
        borderColor: "#FF5733", // Red for Systolic
        backgroundColor: "rgba(255, 87, 51, 0.1)",
        borderWidth: 2,
        hidden: !graphSwitch.Systolic,
      },
      {
        label: "Diastolic",
        data: rpmData.diastolic || [],
        borderColor: "#1D2951", // Blue for Diastolic
        backgroundColor: "rgba(29, 41, 81, 0.1)",
        borderWidth: 2,
        hidden: !graphSwitch.Diastolic,
      },
      {
        label: "Pulse",
        data: rpmData.pulse || [],
        borderColor: "#50C569", // Green for Pulse
        backgroundColor: "rgba(80, 197, 105, 0.1)",
        borderWidth: 2,
        hidden: !graphSwitch.Pulse,
      }
    ],
  };
  
  const getChartDataForTab = () => {
       return filteredChartData
  };

  const wlmChartData = {
    labels: wlmData.datelabel || [],
    datasets: [
      {
        label: "Weight",
        data: wlmData.weight,
        borderColor: "#FFA500", // Orange for Weight
        backgroundColor: "rgba(255, 165, 0, 0.1)",
        borderWidth: 2,
      }
    ],
  };



  

  return (

 <div className="flex flex-col  min-h-0 overflow-y-auto h-[75vh]  always-visible-scrollbar">
  
<div className="w-full mt-1 [font-family:'Inter-SemiBold',Helvetica]  font-semibold text-[#3a405b] text-xl tracking-[1.00px] leading-[17px] whitespace-nowrap">   
          RPM
        <div className="w-auto mt-3">
          <TabsComponent tabs={[{ label: "BPP" }, { label: "WLM" }]} selectedTab={selectedTab} onSelectTab={setSelectedTab} />
        </div>
        </div>
<div>
 {selectedTab === 0 && (
        <div className="flex flex-col flex-1 min-h-0">
           {bpploading ? (
      <div className="w-[100%] flex justify-center mt-10 items-center">
      <CircularProgress />
      </div>// You can replace this with a spinner component if desired
    ) : Object.keys(rpmData).length > 0? ( // Check if there's data available
        <>
      <div className="mt-3 flex-1" style={{ minHeight: "300px" }}>
  <LineChart 
    selectedTab={0}
    graphSwitch={graphSwitch}
    resdata={rpmData}
  />
</div>

 <div className="flex flex-wrap justify-center items-center mt-5 gap-2">
          <div className="flex gap-5">
            <div
              onClick={() => toggleGraph("Systolic")}
              className="text-center [font-family:'Inter-Regular',Helvetica] font-normal text-base tracking-[0] leading-5 whitespace-nowrap"
              style={{
                borderBottom: graphSwitch.Systolic
                  ? "3px solid #E17954"
                  : "none",
                paddingBottom: "5px",
                color: "#E17954",
                width: "33%",
                cursor: "pointer",
              }}
            >
              Systolic
            </div>
            <div
              onClick={() => toggleGraph("Diastolic")}
              className="text-center [font-family:'Inter-Regular',Helvetica] font-normal text-base tracking-[0] leading-5 whitespace-nowrap"
              style={{
                borderBottom: graphSwitch.Diastolic
                  ? "3px solid #1D2951"
                  : "none",
                paddingBottom: "5px",
                color: "#1D2951",
                width: "33%",
                cursor: "pointer",
              }}
            >
              Diastolic
            </div>
            <div
              onClick={() => toggleGraph("Pulse")}
              className="text-center [font-family:'Inter-Regular',Helvetica] font-normal text-base tracking-[0] leading-5 whitespace-nowrap"
              style={{
                borderBottom: graphSwitch.Pulse
                  ? "3px solid #50C569"
                  : "none",
                paddingBottom: "5px",
                color: "#50C569",
                width: "33%",
                cursor: "pointer",
              }}
            >
              Pulse
            </div>
          </div>
        </div>
        </>
    ) : (
      <div>No Data Available</div> // Message when no data is present
    )}
        </div>
        
        )}
{selectedTab === 1 && (
  <div>
    <div className="mt-3">
      {isLoading ? ( // Check for loading state for WLM
       <div className="w-[100%] flex justify-center mt-10 items-center">
       <CircularProgress />
       </div>
      ) : wlmData && wlmData.weight && wlmData.weight.length > 0 ? ( // Check if WLM data is available
<WLMLineChart resdata={wlmData} />

      ) : (
        <div>No Data Available</div> // Message when no data is present
      )}
    </div>
  </div>
)}
</div>
 



<div className="mt-2">

<div className="">
<div className="flex-1 min-h-0 overflow-y-auto overflow-x-auto rounded-lg max-h-72 mb-6">
  <table className="min-w-full border-collapse table-auto rounded text-start">

    {/* Table Header */}
    <thead className="bg-gray-100 sticky top-0 z-10">
      <tr>
        <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">
          Date
        </th>

        {selectedTab === 0 ? (
          <>
            <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">
              Systolic
            </th>
            <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">
              Diastolic
            </th>
            <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">
              Pulse
            </th>
          </>
        ) : (
          <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">
            Weight
          </th>
        )}
      </tr>
    </thead>

    {/* Table Body */}
    <tbody>
      {/* Loading */}
      {dataLoading ? (
        <tr>
          <td
            colSpan={selectedTab === 0 ? 4 : 2}
            className="text-center py-6"
          >
            <div className="flex justify-center">
              <CircularProgress size={24} />
            </div>
          </td>
        </tr>
      ) : selectedTab === 0 ? (
        rpmData?.datelabel?.length > 0 ? (
          rpmData.datelabel.map((date, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="border px-4 py-2 text-center text-[#09090B] text-[13px] font-semibold">
                {date}
              </td>

              <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">
                {rpmData?.systolic?.[index] ?? "N/A"}
              </td>

              <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">
                {rpmData?.diastolic?.[index] ?? "N/A"}
              </td>

              <td className="border px-4 py-2 text-center text-[#2563EB] text-[14px]">
                {rpmData?.pulse?.[index] ?? "N/A"}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={4}
              className="text-center py-6 text-gray-500 font-medium"
            >
              No Data Found
            </td>
          </tr>
        )
      ) : wlmData?.datelabel?.length > 0 ? (
        wlmData.datelabel.map((date, index) => (
          <tr key={index} className="hover:bg-gray-50">
            <td className="border px-4 py-2 text-center text-[#09090B] text-[13px] font-semibold">
              {date}
            </td>

            <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">
              {wlmData?.weight?.[index] ?? "N/A"}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td
            colSpan={2}
            className="text-center py-6 text-gray-500 font-medium"
          >
            No Data Found
          </td>
        </tr>
      )}
    </tbody>

  </table>
</div>
  </div>
</div>
  </div>
        
  
      



      

  );
};

export default RPM;
